import { App } from '../main'

export function errorMessage (err, defaultMessage) {
  return err.data 
    ? App.$bus.$emit('toastError', 'Error: ' + err.data.message)
    : App.$bus.$emit('toastError', defaultMessage)
}



// WEBPACK FOOTER //
// ./src/modules/Error.js